import React, { useContext, useEffect } from 'react';
import { Loader } from '@ferris/react/components/loader';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { shallowEqual, useSelector } from 'react-redux';
import { VR_PROPERTY_CREATION } from '../PageFlow/PageList';
import { createPageViewEvent } from '../../utils/EventProviders/EgClickstreamUtil';
import { VrboCtx } from '../../contexts/vrbo';
import TranslationUtil from '../../utils/TranslationUtil';
import SubmitButton from '../Button/SubmitButton';
import PropertyCreationErrorBanner, { ErrorCodes } from './PropertyCreationErrorBanner';

function VrPropertyCreation() {
    const {
        triggerPropertyCreation,
        loading
    } = useContext(VrboCtx);
    const { trigger } = useContext(TrackingContext);

    const getPropsFromState = ({ app, hydration }) => {
        const {
            createPropertyError,
            translations,
            fallbackTranslations
        } = app;
        const translationsUtil = new TranslationUtil(translations, fallbackTranslations);

        const { hydrationComplete } = hydration;
        const isLocationError = createPropertyError === ErrorCodes.INCOMPLETE_PROPERTY;
        const isPropertyError = Boolean(createPropertyError);
        return {
            hydrationComplete,
            isLocationError,
            isPropertyError,
            estimateButtonLabel: translationsUtil.getTranslation('Vrbo.cta.next')
        };
    };

    const {
        isLocationError,
        isPropertyError,
        estimateButtonLabel,
        hydrationComplete
    } = useSelector(getPropsFromState, shallowEqual);

    const VrPropertyCreationTrigger = () => {
        triggerPropertyCreation(VR_PROPERTY_CREATION);
    };

    useEffect(() => {
        if (hydrationComplete) {
            VrPropertyCreationTrigger();
        }
    }, [hydrationComplete]);

    useEffect(() => {
        trigger('pageview', createPageViewEvent('joinconfirmation', VR_PROPERTY_CREATION, '1.12.1'));
    }, []);

    return (
        <div className="update-account-wrapper">
            <PropertyCreationErrorBanner isDismissable={false} />

            {!isPropertyError && <Loader visible />}
            {(isPropertyError && !isLocationError)
                && (
                    <SubmitButton
                        data-wdio="next-button"
                        animated={loading}
                        label={estimateButtonLabel}
                        disabled={loading}
                        onClick={VrPropertyCreationTrigger}
                    />
                )}

        </div>
    );
}

VrPropertyCreation.displayName = VR_PROPERTY_CREATION;
export default VrPropertyCreation;
